<template>
	<div>
		<h2>
			{{$t('edit')}}
			<div class="float-right">
				<button @click="save" class="btn btn-primary" v-if="workbook.workbook_title">{{ $t('save') }}</button>
			</div>
		</h2>

		<div v-if="saved">
			<div class="alert alert-success mt-8">{{$t('saved')}}</div>
		</div>

		<div class="form-group">
			<div class="form-group">
				<label for="workbook-title">{{$t('title')}}</label>
				<input id="workbook-title" name="tagname" class="form-control" v-model="workbook.workbook_title" :placeholder="$t('title')" required>
			</div>
			<div class="form-group">
				<label for="workbook-description">{{$t('description')}}</label>
				<textarea-autosize
					id="workbook-description"
					class="form-control align-top"
					v-model="workbook.workbook_description"
					@keydown.native="checkWords"
				></textarea-autosize>
			</div>
		</div>

    </div>
</template>

<script>
export default {
	components: {
	},
    data: function() {
        return {
        	workbook: {
        		workbook_id: null,
        		workbook_title: '',
        		workbook_description: ''
        	},
        	saved: false
        }
    },
    methods: {
    	save() {

        	var data = this.workbook;
        	data.save = true;

  			this.$cfetch(`${this.$settings.APIBaseURL}/workbooks/item`, {
  				method: 'post',
  				data
  			})
			.then(json => {
				if (json.status == 'SUCCESS') {
					this.$router.push('/settings/workbooks');
					/*
					this.tag = json.tag;
					this.saved = true;
					setTimeout(() => {
						this.saved = false;
					}, 5000);
					*/
				}
			}).catch(error => {
				this.$log.error.call(this, error);
			});
    	},
    	getItem(id) {
  			this.$cfetch(`${this.$settings.APIBaseURL}/workbooks/item`, {
  				data: {
  					workbook_id: id
  				}
  			})
			.then(json => {
				this.$store.commit("hideBlockingSpinner");
				if (json.status == 'SUCCESS') {
					this.workbook = json.workbook;
				} else {
					this.$router.push('/settings/workbooks');
				}
			}).catch(error => {
				this.$log.error.call(this, error);
				this.$router.push('/settings/workbooks');
			});
    	},
    },
    computed: {

    },
    mounted() {
    	if(this.$route.params.workbookid) {
    		this.getItem(this.$route.params.workbookid);
    	} else {
    		this.$store.commit("hideBlockingSpinner");
    	}
    }
}
</script>
